export const vendorConfigs = [
  {
    tenantId: 1152,
    id: "brose",
    displayName: "Brose",
    type: "employer",
  },
  {
    tenantId: 1669,
    id: "thatch",
    displayName: "Thatch Health, Inc.",
    type: "employer",
  },
  {
    tenantId: -1, // Checked with Sabrina, partner do not go through employer dashboard, so we dont need to check their tenantId
    id: "oneeleven",
    displayName: "OneEleven",
    type: "partner",
  },
  {
    tenantId: -1,
    id: "perks",
    displayName: "Perks",
    type: "partner",
  },
  {
    tenantId: -1,
    id: "demo",
    displayName: "[Your company name]",
    type: "employer",
  },
] as const;

export type VendorConfigIds = typeof vendorConfigs[any]["id"];

export const getVendor = (vendor: VendorConfigIds) => {
  return vendorConfigs.find((item) => item.id === vendor);
};

export const getVendorIds = () => {
  return vendorConfigs.map((item) => item.id).sort();
};

export const getVendorByTenantId = (tenantId: number) => {
  return vendorConfigs.find((item) => item.tenantId === tenantId);
};
